import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh, setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/"); return; }
    const session_id = match[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (data.token) localStorage.setItem("madafrica_token", data.token);
        if (data.user) setUser(data.user);
        // Clean URL
        window.history.replaceState({}, "", "/");
        navigate("/");
      } catch (e) {
        navigate("/login");
      }
    })();
  }, [navigate, refresh, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <p className="text-white/60">Connexion en cours...</p>
    </div>
  );
};

export default AuthCallback;
